export const selectOptionsPrepaymentPenaltyStructure = [
  "5% 5% 5% 5% 5%",
  "1% 1% 1% 1% 1%",
  "5% 4% 3% 2% 1%",
  "4% 3% 2% 1%",
  "3% 2% 1%",
  "2% 1%",
  "1%",
  "Interest Payments",
  "Other Points",
];
